import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b60cd002"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chooseTemplate" }
const _hoisted_2 = { class: "template" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "template__title" }, "从模板新建", -1))
const _hoisted_4 = { class: "template__list" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "modalInfo" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "main" }
const _hoisted_10 = { class: "main__templateDetail" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "custom-arrow" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "custom-dots" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "main__footer" }
const _hoisted_18 = { class: "main__footer__actions" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 取消 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 创建空间 ")


const __default__ = {
  name: 'TeamTemplate'
}

import { ref, onMounted } from 'vue'
import { getGroupTemplates } from '@teams/common/api'
import { NCard, NEllipsis, NCarousel } from 'naive-ui'
import { ArrowBack, ArrowForward } from '@vicons/ionicons5'
import handleResponseError from '@teams/common/hooks/useResponseError'

export type TemplateType = {
  avatar: string
  cover: string[] // 模板封面地址，多个图片将以逗号分隔
  desc: string
  id: number
  intro: string
  name: string
  teamId: string
  topic: string
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    onCancel: null,
    onOk: null
  },
  setup(__props: any) {

const templateList = ref<TemplateType[]>([])
const currentTemplateInfo = ref<TemplateType>()


// 切换的模板
const changeShowTemplate = (info: TemplateType) => {
  currentTemplateInfo.value = info
}

// 初始化模板List
const getTemplateList = async () => {
  try {
    const { data } = await getGroupTemplates()
    templateList.value = data.templates.map(item => {
      return {
        avatar: item.avatar,
        cover: item.cover.split(','),
        desc: item.desc,
        id: item.id,
        intro: item.intro,
        name: item.name,
        teamId: item.team_id,
        topic: item.topic
      }
    })
    currentTemplateInfo.value = templateList.value[0]
  } catch (e) {
    handleResponseError(e)
  }
}
onMounted(() => {
  getTemplateList()
})

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!
  const _component_n_icon = _resolveComponent("n-icon")!

  return (_openBlock(), _createBlock(_unref(NCard), {
    style: {"width":"1120px","min-width":"1120px","min-height":"654px"},
    bordered: false,
    size: "huge",
    role: "dialog",
    "aria-modal": "true"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_n_scrollbar, { style: {"max-height":"530px"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_n_button, {
                    quaternary: "",
                    key: item.id,
                    class: _normalizeClass([
                'template__list__item',
                currentTemplateInfo.value?.id === item.id ? 'currentTemplate' : ''
              ]),
                    onClick: ($event: any) => (changeShowTemplate(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: item.avatar,
                        alt: "",
                        class: "modalImg"
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_unref(NEllipsis), { style: {"max-width":"180px"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_unref(NEllipsis), { style: {"max-width":"180px"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.intro), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(NCarousel), {
              "show-arrow": "",
              autoplay: ""
            }, {
              arrow: _withCtx(({ prev, next }) => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "custom-arrow--left",
                    onClick: prev
                  }, [
                    _createVNode(_component_n_icon, { size: "20" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowBack))
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_13),
                  _createElementVNode("button", {
                    type: "button",
                    class: "custom-arrow--right",
                    onClick: next
                  }, [
                    _createVNode(_component_n_icon, { size: "20" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowForward))
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_14)
                ])
              ]),
              dots: _withCtx(({ total, currentIndex, to }) => [
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(total, (index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: _normalizeClass({ ['is-active']: currentIndex === index - 1 }),
                      onClick: ($event: any) => (to(index - 1))
                    }, null, 10, _hoisted_16))
                  }), 128))
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTemplateInfo.value?.cover, (item) => {
                  return (_openBlock(), _createElementBlock("img", {
                    class: "carousel-img",
                    key: item,
                    src: item,
                    alt: currentTemplateInfo.value?.name
                  }, null, 8, _hoisted_11))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_n_button, {
                class: "cancelButton",
                onClick: __props.onCancel
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_n_button, {
                class: "createButton",
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.onOk(currentTemplateInfo.value?.id)))
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})